<template>
    <v-dialog
            @click:outside="closeDialog"
            @keydown.esc="closeDialog"
            max-width="752px"
            v-model="dialog">
        <template v-slot:activator="{ on }">
            <slot name="activator">
            </slot>
        </template>
        <v-card class="dialog-card">
            <router-view name="projects-form">
            </router-view>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "ProjectsDialog",
        props: ['isDialogOpened'],
        data: () => ({
            dialog: null
        }),
        methods: {
            openDialog: function () {
                this.dialog = true;
            },
            closeDialog: function () {
                this.dialog = false;
                this.$emit('dialogClosed')
            },
        },
        watch: {
            isDialogOpened: {
                handler: function (val) {
                    if (val !== undefined) {
                        this.dialog = eval(val);
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
